import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './blotter.less';
import { Spin } from 'antd';
import InlineSVG from 'react-inlinesvg';
import emptyStateIcon from '../../assets/empty_state.svg';

export default class Blotter extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    emptyStateText: PropTypes.string
  };

  static defaultProps = {
    loading: false
  };

  renderHeader(colSize) {
    return (
      <div className={'blotter-header'}>
        {this.props.columns.map(({ title, colSpan, key }) => (
          <div
            key={key}
            style={{ width: `${colSize * (colSpan || 1)}%` }}
            className={'blotter-cell-wrapper'}
          >
            <div className={'blotter-cell'}>{title}</div>
          </div>
        ))}
      </div>
    );
  }
  renderBody(colSize) {
    return (
      <div
        className={classnames('blotter-body-wrapper', {
          loading: this.props.loading
        })}
      >
        {this.props.loading ? <Spin size="large" /> : null}
        <div className={classnames('blotter-body')}>
          {this.props.dataSource.length
            ? this.props.dataSource.map((rowData, key) => (
                <div key={key}>
                  {this.renderCard(rowData)}
                  {this.renderRow(rowData, colSize)}
                </div>
              ))
            : this.emptyState}
        </div>
      </div>
    );
  }

  get emptyState() {
    return (
      <div className={'empty-state'}>
        <InlineSVG src={emptyStateIcon} className={'icon'} />
        {this.props.emptyStateText ? (
          <span className={'empty-state__text'}>
            {this.props.emptyStateText}
          </span>
        ) : null}
      </div>
    );
  }

  renderCard(rowData) {
    return (
      <div className={'blotter-card'}>
        {this.props.columns.map(({ title, key, render, dataIndex }) => (
          <div className={'blotter-card-row'} key={key}>
            <div className={'blotter-card-label'}>{title}</div>
            <div className={'blotter-card-content'}>
              {render ? render(rowData) : rowData[dataIndex]}
            </div>
          </div>
        ))}
      </div>
    );
  }
  renderRow(rowData, colSize) {
    return (
      <div className={'blotter-row'}>
        {this.props.columns.map(
          ({ title, key, render, colSpan, dataIndex }) => (
            <div
              key={key}
              style={{ width: `${colSize * (colSpan || 1)}%` }}
              className={'blotter-cell-wrapper'}
            >
              <div className={'blotter-cell'}>
                {render ? render(rowData) : rowData[dataIndex]}
              </div>
            </div>
          )
        )}
      </div>
    );
  }
  render() {
    const numColumns = this.props.columns.reduce(
      (colCount, column) => colCount + (column.colSpan || 1),
      0
    );
    const colSize = 100 / numColumns;
    return (
      <div className={'blotter'}>
        {this.renderHeader(colSize)}
        {this.renderBody(colSize)}
      </div>
    );
  }
}
